export default "__VITE_ASSET__DG9EG7Hi__"